/**
 * Client-side paged loader factory for Buildings listing.
 *
 * Converts a static option array into a `loadOptions` function compatible with
 * `PagedMultiSelectFilter`. Used for territories passed as static props from
 * the server (territoriesForSelect).
 */
const PAGE_SIZE = 50;
/**
 * Returns a `loadOptions` callback that filters/paginates through a static array.
 *
 * - Filtering: case-insensitive substring match on `label`.
 * - Pagination: cursor is a stringified offset number.
 * - Returns `nextCursor` when more items exist beyond the current page.
 */
export function createArrayLoader(items, toOption) {
    const defaultToOption = (item) => ({
        value: item.value,
        label: item.label
    });
    const mapItem = toOption !== null && toOption !== void 0 ? toOption : defaultToOption;
    return (query, cursor) => {
        const q = query.trim().toLowerCase();
        const filtered = q ? items.filter((item) => item.label.toLowerCase().includes(q)) : [...items];
        const offset = cursor ? parseInt(cursor, 10) : 0;
        const page = filtered.slice(offset, offset + PAGE_SIZE);
        const hasMore = offset + PAGE_SIZE < filtered.length;
        return Promise.resolve({
            options: page.map(mapItem),
            nextCursor: hasMore ? String(offset + PAGE_SIZE) : undefined
        });
    };
}
